import { render } from "./Paso5AyudaComponent.vue?vue&type=template&id=65314012"
import script from "./Paso5AyudaComponent.vue?vue&type=script&lang=js"
export * from "./Paso5AyudaComponent.vue?vue&type=script&lang=js"

import "./Paso5AyudaComponent.vue?vue&type=style&index=0&id=65314012&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__